import { Subscription } from '../../util/rxjs';

export const enum UploadStatus {
  Ready,
  Uploading,
  Complete,
  Failed,
  Duplicate
}

export const enum FileStatus {
  Successful    = 0,
  ErrorIsFolder = 1 << 0,
  ErrorTooLarge = 1 << 1
}

export interface FileUpload {
  name: string;
  progress: number;
  status: UploadStatus;

  file: File;
  upload?: Subscription;
}

export interface FileResult {
  name: string;
  status: FileStatus;
}
